import { css } from '@emotion/core';

const smallViewportStyles = {
  button: css`
    @media (max-width: 320px) {
      margin: 0 !important;
    }
  `,
  menu: css`
    @media (max-width: 320px) {
      margin 0 0 .25rem 0;
      width: 100%;
    }
  `
};

const styles = (theme, position, isMenuOpen, variant, disabled) => ({
  buttonContainer: css`
    margin-left: 0 !important;
    margin-bottom: 2px !important;

    ${['split', 'text', 'text-icon'].includes(variant) &&
      smallViewportStyles.button}

    ${variant === 'icon' &&
    `border-color: ${
      isMenuOpen
        ? theme && theme.vds && theme.vds.buttonIconLightHover
          ? theme.vds.buttonIconLightHover
          : '#0051dc'
        : theme && theme.vds && theme.vds.buttonIcon
        ? theme.vds.buttonIcon
        : '#003ea9'
    } !important;}
      background-color: ${
        isMenuOpen
          ? theme?.cybs?.core?.primary ?? '#1434CB'
          : theme && theme.vds && theme.vds.transparent
          ? theme.vds.transparent
          : 'rgba(0,0,0,0)'
      } !important;
        &.vds-btn-icon--light [class^='vds-icon'] use {
          fill: ${
            isMenuOpen
              ? theme?.cybs?.base?.wcag21?.white ?? '#ffffff'
              : disabled
              ? theme?.cybs?.base?.wcag21?.disabledGrey ?? '#00000033'
              : theme?.vds?.buttonIcon ?? '#003ea9'
          } !important;
        }

        &.vds-btn-icon--light:focus:not(:active) {
          background-color: ${theme?.vds?.tableHighlight ?? '#C7EDFF'} !important;
        }
      `}
  `,
  menuContainer: css`
    display: inline-block;
    position: relative;
    & .vds-listbox {
      width: 15rem !important;
      border-color: ${theme?.vds?.primaryExtraDark2 ?? '#021E4C'} !important;
    }
    & .vds-listbox-item {
      color: ${theme?.cybs?.base?.wcag21?.charcoal ?? '#000000'};
      &:hover {
        outline: 1px solid transparent !important;
        outline-offset: -2px !important;
      }

      &.vds-state--disabled:not(.cybs-listbox-item-section) {
        color: ${theme?.cybs?.base?.wcag21?.stoneGrey ?? '#62798D'};
      }  
    }
    & .vds-listbox-item.vds-state--nested-selected {
      outline: 1px dashed ${theme?.cybs?.base?.wcag21?.white ?? '#ffffff'} !important;
      outline-offset: -2px !important;

      &::after {
        display: none !important;
      }
    }
    ${['split', 'text', 'text-icon'].includes(variant) &&
      smallViewportStyles.menu}
  `,
  menuButtonWrapper: css`
    position: absolute;
    z-index: 2;
    ${position?.horizontal === 'right' ? 'right: 0;' : 'left: 0;'}
  `
});

export default styles;